import { Injectable } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { UserTransferDto } from '../interfaces/user-transfer.dto';
import { BatchTransfersDto } from '../interfaces/batch-transfers.dto';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { BatchTransfersResponseDto } from '../interfaces/batch-transfer-response.dto';

@Injectable({
  providedIn: 'root',
})
export class DigitalWalletService {
  private readonly balance = new BehaviorSubject<any>({});
  currentBalance = this.balance.asObservable();
  private readonly apiUrl = environment.api.url;

  constructor(
    private readonly fns: AngularFireFunctions,
    private readonly http: HttpClient
  ) {}

  getBalance() {
    return this.balance;
  }

  getBalanceValue() {
    const balanceData = this.getBalance() as any;
    return balanceData._value;
  }

  setBalance(balance: any) {
    this.balance.next(balance);
      // Llamada ligera a Cloud Function para verificar inversiones
    this.fns.httpsCallable('checkUserMPInvestments')({})
    .subscribe({
      next: (res) => {
        console.log('Verificación de inversiones en Cloud completada:', res);
      },
      error: (err) => {
        console.error('Error en checkUserMPInvestments:', err);
      }
    });
  }

  checkFunds() {
    this.setBalance({
      ...this.getBalanceValue(),
      isLoadingBalance: true,
    });
    this.fns
      .httpsCallable('getWalletMangoPay')({})
      .subscribe({
        next: (res: any) => {
          this.setBalance({
            balanceError: false,
            balance: res.Balance.Amount / 100,
            isLoadingBalance: false, // ✅ Quitar loading inmediatamente
            //balance : 0
          });
        },
        error: (error: any) => {
          console.log(error.message);
          this.setBalance({
            balanceError: true,
            balance: 0,
            isLoadingBalance: false, // ✅ Quitar loading inmediatamente
          });
        },
      });
  }

  // ✅ Método eliminado: executeTimeOut() ya no es necesario

  async checkBatchTransfers(
    transfers: UserTransferDto[],
    walletId: string
  ): Promise<BatchTransfersResponseDto> {
    const body = { transfers: transfers, sourceWallet: Number(walletId) };
    return await firstValueFrom(
      this.http.post<BatchTransfersResponseDto>(
        `${this.apiUrl}/bank/check-batch-transfers`,
        body
      )
    );
  }

  async processBatchTransfers(
    transfers: UserTransferDto[],
    walletId: string,
    twoFactorCode: string
  ): Promise<BatchTransfersDto> {
    const body: BatchTransfersDto = { 
      transfers: transfers, 
      sourceWallet: Number(walletId),
      twoFactorCode: twoFactorCode
    };
    return await firstValueFrom(
      this.http.post<BatchTransfersDto>(`${this.apiUrl}/bank/batch-transfers`, body)
    );
  }
}
